module.exports = __webpack_public_path__ + "static/media/download.32874452.svg";